import { render, staticRenderFns } from "./VatSettings.vue?vue&type=template&id=1400fcf3&scoped=true&"
import script from "./VatSettings.vue?vue&type=script&lang=js&"
export * from "./VatSettings.vue?vue&type=script&lang=js&"
import style0 from "./VatSettings.vue?vue&type=style&index=0&id=1400fcf3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1400fcf3",
  null
  
)

export default component.exports